import {observer} from "mobx-react-lite";
import React from "react";
import {SortableSelectorsGrid} from "./selectors/SortableSelectorsGrid";
import {ReadAllPresetsButton} from "./ReadAllPresetsButton";

export const PresetsGrid = observer(() => {

    return (
        <div className="presets-grid main-content px-20 mt-20">
            {/*<div className="px-20 mt-20 scroll-y">*/}
                <ReadAllPresetsButton maxPreset={105} />
                <SortableSelectorsGrid />
            {/*</div>*/}
        </div>
    );

})